import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';

class Sidebar extends Component {

  state = {
    localStorageValue: null,
    userRole: 'Admin',
  };

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  // Function to get an item from localStorage
  getLocalStorageItem(key) {
    return localStorage.getItem(key);
  }


  // componentDidMount() {
  //   const localStorageKey = 'username'; // Replace with your actual key
  //   const localStorageValue = this.getLocalStorageItem(localStorageKey);
  //   console.log('localStorageValue:', localStorageValue);
  //   alert("';lkjnlk;jnbh;klj")
  //   // Update state only if a value is retrieved
  //   if (localStorageValue !== null) {
  //     this.setState({ localStorageValue });
  //   }
  // }


  componentDidMount() {
    this.onRouteChanged();
    this.setState({
      localStorageValue: localStorage.getItem('fullname') || 'Administrator',
      userRole: localStorage.getItem('role') || 'Admin',
    });
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: '/apps', state: 'appsMenuOpen' },
      { path: '/basic-ui', state: 'basicUiMenuOpen' },
      { path: '/form-elements', state: 'formElementsMenuOpen' },
      { path: '/tables', state: 'tablesMenuOpen' },
      { path: '/icons', state: 'iconsMenuOpen' },
      { path: '/data', state: 'datasMenuOpen' },
      { path: '/charts', state: 'chartsMenuOpen' },
      { path: '/declaration', state: 'declarationMenuOpen' },
      { path: '/notification', state: 'notificationMenuOpen' },
      { path: '/user-pages', state: 'userPagesMenuOpen' },
      { path: '/hotels', state: 'hotelsMenuOpen' },
      { path: '/agent', state: 'agentMenuOpen' },
      { path: '/error-pages', state: 'errorPagesMenuOpen' },
    ];

    dropdownPaths.forEach((obj => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true })
      }
    }));

  }


  render() {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="sidebar-brand-wrapper d-none d-lg-flex align-items-center justify-content-center fixed-top">
          <a className="sidebar-brand brand-logo" href={() => false} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#fff', textDecoration: 'none', fontWeight: '700', fontSize: '1.05rem', letterSpacing: '0.08em' }}>
            <span style={{ fontSize: '1.3rem' }}>✈</span>
            HAMSYL
          </a>
          <a className="sidebar-brand brand-logo-mini" href="index.html"><img src={require('../../assets/images/logo-mini.svg')} alt="logo" /></a>
        </div>
        <ul className="nav">
          <li className="nav-item profile">
            <div className="profile-desc">
              <div className="profile-pic">
                <div className="count-indicator">
                  <div className="img-xs rounded-circle d-flex align-items-center justify-content-center" style={{ background: 'linear-gradient(135deg, #1a73e8, #0d47a1)', color: '#fff', fontWeight: 700, fontSize: '0.85rem', border: '2px solid #1a73e8', width: 36, height: 36 }}>
                    {(this.state.localStorageValue || 'A').charAt(0).toUpperCase()}
                  </div>
                  <span className="count bg-success"></span>
                </div>
                <div className="profile-name">
                  <h5 className="mb-0 font-weight-normal">{this.state.localStorageValue || 'Administrator'}</h5>
                  <span>{this.state.userRole}</span>
                </div>
              </div>
            </div>
          </li>

          <li className="nav-item nav-category">
            <span className="nav-link" style={{ fontSize: '0.7rem', fontWeight: '700', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#94a3b8', padding: '1rem 1.188rem 0.5rem' }}><Trans>Navigation</Trans></span>
          </li>

          <li className={this.isPathActive('/dashboard') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <Link className="nav-link" to="/dashboard">
              <span className="menu-icon"><i className="mdi mdi-view-dashboard"></i></span>
              <span className="menu-title"><Trans>Dashboard</Trans></span>
            </Link>
          </li>

          {/* <li className={this.isPathActive('/basic-ui') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.basicUiMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('basicUiMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-laptop"></i>
              </span>
              <span className="menu-title"><Trans>Basic UI Elements</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.basicUiMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/basic-ui/buttons') ? 'nav-link active' : 'nav-link'} to="/basic-ui/buttons"><Trans>Buttons</Trans></Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/basic-ui/dropdowns') ? 'nav-link active' : 'nav-link'} to="/basic-ui/dropdowns"><Trans>Dropdowns</Trans></Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/basic-ui/typography') ? 'nav-link active' : 'nav-link'} to="/basic-ui/typography"><Trans>Typography</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li> */}

          {/* <li className={this.isPathActive('/form-elements') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.formElementsMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('formElementsMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-playlist-play"></i>
              </span>
              <span className="menu-title"><Trans>Form Elements</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.formElementsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/form-elements/basic-elements') ? 'nav-link active' : 'nav-link'} to="/form-elements/basic-elements"><Trans>Basic Elements</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li> */}

          {/* <li className={this.isPathActive('/form-elements') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.declarationMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('declarationMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-playlist-play"></i>
              </span>
              <span className="menu-title">Voucher</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.declarationMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/declaration/voucher-list') ? 'nav-link active' : 'nav-link'} to="/declaration/voucher-list">Declaration voucher list</Link></li>
                </ul>
              </div>
            </Collapse>
          </li> */}

          <li className={this.isPathActive('/tables') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.tablesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('tablesMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-file-document-outline"></i>
              </span>
              <span className="menu-title">Records</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.tablesMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/tables/basic-table') ? 'nav-link active' : 'nav-link'} to="/tables/basic-table"><Trans>Basic Table</Trans></Link></li> */}
                  <li className="nav-item"> <Link className={this.isPathActive('/tables/record-list') ? 'nav-link active' : 'nav-link'} to="/tables/record-list"><Trans>Record List</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li>

          <li className={this.isPathActive('/data') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.datasMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('datasMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-magnify"></i>
              </span>
              <span className="menu-title">Data search</span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.datasMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/data/search-list') ? 'nav-link active' : 'nav-link'} to="/data/search-list">Data search list</Link></li>
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/data/arrivals') ? 'nav-link active' : 'nav-link'} to="/data/arrivals">Arrivals</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/data/departures') ? 'nav-link active' : 'nav-link'} to="/data/departures">Deprtures</Link></li> */}
                </ul>
              </div>
            </Collapse>
          </li>

          <li className={this.isPathActive('/notification') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.notificationMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('notificationMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-bell-outline"></i>
              </span>
              <span className="menu-title">Notifications</span>
              <i className="menu-arrow"></i>
            </div>

            <Collapse in={this.state.notificationMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/tables/basic-table') ? 'nav-link active' : 'nav-link'} to="/tables/basic-table"><Trans>Basic Table</Trans></Link></li> */}
                  <li className="nav-item"> <Link className={this.isPathActive('/notification/notification-list') ? 'nav-link active' : 'nav-link'} to="/notification/notification-list"><Trans> Notification</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li>

          {/* <li className={this.isPathActive('/charts') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.chartsMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('chartsMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-chart-bar"></i>
              </span>
              <span className="menu-title"><Trans>Charts</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.chartsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/charts/chart-js') ? 'nav-link active' : 'nav-link'} to="/charts/chart-js"><Trans>Chart Js</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li> */}

          {/* <li className={this.isPathActive('/icons') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.iconsMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('iconsMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-contacts"></i>
              </span>
              <span className="menu-title"><Trans>Icons</Trans></span>
              <i className="menu-arrow"></i>
            </div>
            <Collapse in={this.state.iconsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/icons/mdi') ? 'nav-link active' : 'nav-link'} to="/icons/mdi"><Trans>Material</Trans></Link></li>
                </ul>
              </div>
            </Collapse>
          </li> */}

          <li className={this.isPathActive('/hotels') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.hotelsMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('hotelsMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-hotel"></i>
              </span>
              <span className="menu-title">Hotels</span>
              <i className="menu-arrow"></i>
            </div>

            <Collapse in={this.state.hotelsMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/hotel/list/available') ? 'nav-link active' : 'nav-link'} to="/hotel/list/available">Hotel List Available</Link></li>
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/user-pages/login-1') ? 'nav-link active' : 'nav-link'} to="/user-pages/login-1"><Trans>Login</Trans></Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/user-pages/register-1') ? 'nav-link active' : 'nav-link'} to="/user-pages/register-1"><Trans>Register</Trans></Link></li> */}
                </ul>
              </div>
            </Collapse>
          </li>

          <li className={this.isPathActive('/agent') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.agentMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('agentMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-account-tie"></i>
              </span>
              <span className="menu-title">Agents</span>
              <i className="menu-arrow"></i>
            </div>

            <Collapse in={this.state.agentMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/agent/new/form') ? 'nav-link active' : 'nav-link'} to="/agent/new/form">New agent</Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/agent/list/table') ? 'nav-link active' : 'nav-link'} to="/agent/list/table">Agent table list</Link></li>
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/user-pages/register-1') ? 'nav-link active' : 'nav-link'} to="/user-pages/register-1"><Trans>Register</Trans></Link></li> */}
                </ul>
              </div>
            </Collapse>
          </li>

          <li className={this.isPathActive('/user-pages') ? 'nav-item menu-items active' : 'nav-item menu-items'}>
            <div className={this.state.userPagesMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('userPagesMenuOpen')} data-toggle="collapse">
              <span className="menu-icon">
                <i className="mdi mdi-account-multiple-outline"></i>
              </span>
              <span className="menu-title"><Trans>Users</Trans></span>
              <i className="menu-arrow"></i>
            </div>

            <Collapse in={this.state.userPagesMenuOpen}>
              <div>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item"> <Link className={this.isPathActive('/auth/new/user/role') ? 'nav-link active' : 'nav-link'} to="/auth/new/user/role">User management</Link></li>
                  {/* <li className="nav-item"> <Link className={this.isPathActive('/user-pages/login-1') ? 'nav-link active' : 'nav-link'} to="/user-pages/login-1"><Trans>Login</Trans></Link></li>
                  <li className="nav-item"> <Link className={this.isPathActive('/user-pages/register-1') ? 'nav-link active' : 'nav-link'} to="/user-pages/register-1"><Trans>Register</Trans></Link></li> */}
                </ul>
              </div>
            </Collapse>
          </li>


          {/* <li className="nav-item menu-items">
            <a className="nav-link" href="http://bootstrapdash.com/demo/corona-react-free/documentation/documentation.html" rel="noopener noreferrer" target="_blank">
              <span className="menu-icon">
                <i className="mdi mdi-file-document-box"></i>
              </span>
              <span className="menu-title"><Trans>Documentation</Trans></span>
            </a>
          </li> */}

        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

}

export default withRouter(Sidebar);